// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedRadioactivity_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s48IconSvg = html `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M21.7557 4.29831C22.7641 2.56723 25.2359 2.56723 26.2443 4.29831L47.6343 41.0178C48.6596 42.7778 47.4072 45 45.39 45H2.60998C0.592772 45 -0.659597 42.7778 0.365678 41.0178L21.7557 4.29831Z" fill="#FDCA40"/>
  <path d="M28.9914 29.7005C28.8957 28.0818 28.0301 26.6702 26.7555 25.827L30.0618 20.8193C32.8659 22.6745 34.7704 25.7799 34.9808 29.341L28.9914 29.7005ZM24 34.9999C24.8542 34.9999 25.6583 34.7858 26.3616 34.4082L29.1955 39.6981C27.6482 40.5288 25.8791 40.9999 24 40.9999 22.1209 40.9999 20.3519 40.5288 18.8046 39.6981L21.6384 34.4082C22.3418 34.7858 23.1459 34.9999 24 34.9999ZM19.0089 29.7005C19.1045 28.0818 19.9702 26.6702 21.2448 25.827L17.9385 20.8193C15.1344 22.6745 13.2299 25.7799 13.0195 29.341L19.0089 29.7005Z" fill="#1A2329"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24.5161 5.30501C24.2792 4.89833 23.7208 4.89833 23.4839 5.30501L2.09384 42.0245C1.82244 42.4904 2.18093 43 2.60998 43H45.39C45.8191 43 46.1776 42.4904 45.9062 42.0245L24.5161 5.30501ZM26.2443 4.29831C25.2359 2.56723 22.7641 2.56723 21.7557 4.29831L0.365678 41.0178C-0.659597 42.7778 0.592772 45 2.60998 45H45.39C47.4072 45 48.6596 42.7778 47.6343 41.0178L26.2443 4.29831Z" fill="#1A2329"/>
  <path d="M27.0001 30C27.0001 31.6569 25.657 33 24.0001 33C22.3433 33 21.0001 31.6569 21.0001 30C21.0001 28.3431 22.3433 27 24.0001 27C25.657 27 27.0001 28.3431 27.0001 30Z" fill="#1A2329"/>
</svg>
`;
/**
 * IconMedRadioactivity is a generated icon component.
 */
let IconMedRadioactivity = IconMedRadioactivity_1 = class IconMedRadioactivity extends IconBaseElement {
    render() {
        return html `${IconMedRadioactivity_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedRadioactivity.icons = new Map([
    ['s8', _s48IconSvg],
    ['s12', _s48IconSvg],
    ['s16', _s48IconSvg],
    ['s24', _s48IconSvg],
    ['s32', _s48IconSvg],
    ['s40', _s48IconSvg],
    ['s48', _s48IconSvg],
    ['s64', _s48IconSvg],
    ['s72', _s48IconSvg],
    ['s80', _s48IconSvg],
]);
IconMedRadioactivity = IconMedRadioactivity_1 = __decorate([
    customElement('zui-icon-med-radioactivity')
], IconMedRadioactivity);
export { IconMedRadioactivity };
